$(document).on('click','.label-list button' , function(){
	$(this).parents('.label-list').find('.label-inner').toggleClass("imp");
});
// 접근성 관련 sns 포커스 관련 이벤트
$(document).on('keyup , keydown', '.pd-share', function(e){
	var $snsAct = $(this).find('.list');
	var $lastSns = $snsAct.find('.sns-share li:last-child > a');
	if($snsAct.hasClass('active')){
		if(e.type == 'keydown'){
			if($lastSns.is(':focus') && e.shiftKey == false){
				if(e.keyCode == 9){
					$snsAct.removeClass('active')
				}
			}
			if(e.shiftKey && e.keyCode == 9 && $(this).find('.sns').is(':focus')){
				$snsAct.removeClass('active')
			}
		} 
	}
});

/* LGEBR-1251 Start */
function priceSyncLazyloadGPC0007(){
	const $obj = $('.GPC0007.plp');
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === 'data-is-vip') {
				priceSyncSet(mutation.target.getAttribute('data-is-vip'))
				preShipmentHide(); //LGEAU-644
		    	observer.disconnect();		    	
				
				// LGENL-276
				promotionTagTextSet();
			}
		});
	});
	observer.observe(document.querySelector('.GPC0007.plp'), {
		attributes: true, childList: false, characterData: false
	});
	
	if($obj.attr('data-is-vip') != 'NULL'){
		priceSyncSet($obj.attr('data-is-vip'));
		preShipmentHide(); //LGEAU-644
		observer.disconnect();		
		
		// LGENL-276
		promotionTagTextSet();
	}
	
	//LGEAU-644 START
	function preShipmentHide(){
		var obsGroupCheck;
		var $labelList = $obj.find('.label-list .label-inner ul');
		 if ( COUNTRY_CODE.toLowerCase()=='au' ) {
			 obsGroupCheck = $('.navigation').attr('data-obs-group');
	         if ( obsGroupCheck == "B2E" ) {
	        	 $labelList.find('.free-delivery').addClass('d-none');
	         } else {
	        	 $labelList.find('.free-delivery').removeClass('d-none');
	         }
		 }
	}
	//LGEAU-644 END
	
	function priceSyncSet(flag){
		if(flag == 'false'){
			priceSyncGPC0007.init();
		}else{
			priceSyncGPC0007.el.find('.products-info').find('.price-area.total').siblings('.member-text.d-none').removeClass('d-none');
			priceSyncGPC0007.el.find('.products-info').find('.price-area.total').siblings('.cheaper-text.d-none').removeClass('d-none');
			priceSyncGPC0007.el.find('.products-info').find('.price-area.total').removeClass('d-none');
			priceSyncGPC0007.el.find('.products-info').find('.price-vip-Installment').removeClass('d-none');
			priceSyncGPC0007.el.find('.products-info').find('.price-area.total').siblings('.regular-price-text.d-none').removeClass('d-none'); //LGCOMNL-486
    	}
	}

	// LGENL-276 LGEDE-933
	function promotionTagTextSet(){
		if( $obj.length > 0 && $obj.attr("data-is-vip") == "true" && $obj.find(".promotionTagText").find(".info-txt").length > 0){
			$obj.find(".promotionTagText").addClass('d-none');
			$obj.find(".promotionTagText").find(".info-txt").addClass('d-none');
			if($obj.find(".promotionText").find(".info-txt").length > 0){
				$obj.find(".promotionText").removeClass('d-none');
				$obj.find(".promotionText").find(".info-txt").removeClass('d-none');
			}
		}else if( $obj.find(".promotionTagText").find(".info-txt").length > 0){
			$obj.find("div[data-promotion-tag-text-flag='Y']").removeClass('d-none');
			$obj.find("div[data-promotion-tag-text-flag='Y']").find(".info-txt").removeClass('d-none');
		}
		
		//LGCOMNL-450 START
		var promotionTagTextPdpLink = $obj.find(".promotionTagText").data('promotion-tag-text-pdp-link');
		var promotionTagTextPdpLinkInLogin = $obj.find(".promotionTagText").data('promotion-tag-text-pdp-link-id-login');
		if(!sessionStorage.getItem('ACCESS_TOKEN')){
			$obj.find(".promotion-tag-text-link").prop('href', promotionTagTextPdpLink);
		}else{
			$obj.find(".promotion-tag-text-link").prop('href', promotionTagTextPdpLinkInLogin);
		}
		//LGCOMNL-450 END
	}
}
/* LGCOMSPEED-6 Start */
window.addEventListener('load', function() {
	const $obj = $('.GPC0007.plp');	
	if($obj.find('input[name=priceSyncLazyload]').val() !== 'N') priceSyncLazyloadGPC0007();
});
/* LGCOMSPEED-6 End */
/* LGEBR-1251 End */

$(document).ready(function() {	
	/* LGCOMSPEED-6 Start */
	const $obj = $('.GPC0007.plp');	
	/* LGCOMSPEED-6 End */

	/* LGEBR-1251 Start */
	if($obj.find('input[name=priceSyncLazyload]').val() == 'N') priceSyncLazyloadGPC0007();
	/* LGEBR-1251 End */
	
	var productType = ($('#resultProductList .cardlist-box').length > 0) ? 'card' : 'default';
	var objModel_ui = function() {
		var $objGroup = $('.GPC0007').find('.model-group');
		$objGroup.each(function() {
			var _this = $(this);
			var obj_ea = _this.find('a').length;
			var group_width = $objGroup.width();
			var obj_width = _this.find('a').outerWidth(true);
			var obj_etc = (obj_ea - 1) * 4; // LGETW-256 : margin 값 계산 수정

			// card type
			if(productType == 'card') {
				_this.find('.btn-limited').remove();
				_this.removeClass('limited');
				_this.find('.under2').removeClass('under2');

				if(obj_ea * obj_width  > group_width){
					_this.addClass('limited');
		
					var countItemViewport = 0;
					var firstItemOffsetTop = _this.find('a').eq(0).offset().top;
					for(var i=0;i<obj_ea;i++) {
						if(_this.find('a').eq(i).offset().top == firstItemOffsetTop) {
							countItemViewport ++;
						}
					}
		
					if(obj_ea - countItemViewport == 0) {
						_this.removeClass('limited');
						_this.find('.btn-limited').remove();
					}
		
					for(var j=0;j<obj_ea;j++) {
						if(j > countItemViewport-1) {
							_this.find('a').eq(j).addClass('under2');
						}
					}
		
					if(!_this.find('button').hasClass('btn-limited')){
						_this.append('<button class="btn-limited">'+ '+ ' + (obj_ea-countItemViewport) + '</button>');
						_this.find('button').on('click', function(e){
							if ($(window).width() < 768){
								_this.toggleClass('open');
								if(_this.hasClass('open')){
									$('.model-group').removeClass('open');
									_this.addClass('open');
								} else{
									_this.removeClass('open');
								}
							}
						});
					} else {
						_this.find('.btn-limited').text('+' + (obj_ea-countItemViewport));
					}
				} else{
					_this.removeClass('limited');
					_this.find('.btn-limited').remove();
				}

				return;  // 카드 타입인 경우 아래 default 코드 실행 안됨
			}
			
			if(obj_ea * obj_width + obj_etc > group_width){
				_this.addClass('limited');
				if(!_this.find('button').hasClass('btn-limited')){
					_this.append('<button class="btn-limited">'+ '(' + obj_ea + ')' +'</button>');
					_this.find('button').on('click', function(e){
						if ($(window).width() < 768){
							_this.toggleClass('open');
							if(_this.hasClass('open')){
								$('.model-group').removeClass('open');
								_this.addClass('open');
							} else{
								_this.removeClass('open');
							}
						}
					});
				}
			} else{
				_this.removeClass('limited');
				_this.find('.btn-limited').remove();
			}
		});
		$(window).on('scroll' ,function(){
			if ($(window).width() < 767){
				$('.label-inner').each( function(i){
					var srlTop = $(window).scrollTop();
					var winH = $(window).innerHeight();
					var harf_pos = winH / 2;
					var obj_pos = $(this).offset().top + harf_pos;
					if( srlTop + winH > obj_pos ){
						$(this).addClass("act");
						$(this).removeClass("imp");
						$(this).parent('.label-list').find('button').attr('disabled', true)
					}  else{
						$(this).removeClass("act");
						$(this).parent('.label-list').find('button').attr('disabled', false)
					}
				});
			} 
		});
	}
	var listBox_resize = function() {
		var $item_width = $('.list-box').find('li > .item').outerWidth();
			if ($(window).width() < 767 || isMobile){
			$('.pd-share').find('.list').addClass('mobileSns')
		} else{
			$('.pd-share').find('.list').css('width', $item_width);
			$('.pd-share').find('.list').removeClass('mobileSns')
		}
	}
	
	$('.btn-listChange').on('click' ,function(){
		$('.btn-listChange').toggleClass("act");
		if($('.btn-listChange').hasClass('act')){
			$(".product-list-box").addClass('rows');
			$('.btn-listChange').attr("data-sc-item", "plp_btn_list_change_to_2");
		}else{
			$(".product-list-box").removeClass('rows');
			$('.btn-listChange').attr("data-sc-item", "plp_btn_list_change_to_1");
		};
		if($('.thumbnail-carousel').hasClass('slick-initialized')){
			$('.thumbnail-carousel').slick('unslick');
			$('.thumbnail-carousel').slick({
				arrows: false,
				dots: true
			});
		} else{
			$('.thumbnail-carousel').slick({
				arrows: false,
				dots: true
			});
		}
		objModel_ui();
	});

	$(window).on('load resize', function() {
		objModel_ui();
		listBox_resize();
	});
	
	//LGEGMCGA-28 Start
	$(document).on('mouseup', '.youreko-energy-label-multiple-grid-border', function(){
		var price = "";
		price = $(this).closest('.products-info').find('.js-compare').attr('data-price');
		if(price == '.' || price == '.00' || price == '0.0' || price== '0'){
			price = "";
		} 
		var msrp = "";
		msrp = $(this).closest('.products-info').find('.js-compare').attr('data-msrp');
		if(msrp == '.' || msrp == '.00' || msrp == '0.0' || msrp == '0'){
			msrp = "";
		} 
		var modelYear = $(this).closest('.products-info').find('.js-compare').attr('data-model-year');
		window.dataLayer.push({
			event: 'energy_saving_label_click',
			bu: $(this).closest('.products-info').find('.js-compare').attr('data-bu'),
			superCategory: $(this).closest('.products-info').find('.js-compare').attr('data-super-category-name'),
			category: $(this).closest('.products-info').find('.js-compare').attr('data-category-name'), 
			subcategory : $(this).closest('.products-info').find('.js-compare').attr('data-sub-category-name'), 
			modelYear : modelYear, 
			modelName : $(this).closest('.products-info').find('.js-compare').attr('data-model-name'), 
			modelCode: $(this).closest('.products-info').find('.js-compare').attr('data-model-id'), 
			salesModelCode: $(this).closest('.products-info').find('.js-compare').attr('data-model-salesmodelcode'), 
			sku: $(this).closest('.products-info').find('.js-compare').attr('data-sku'),
			suffix: $(this).closest('.products-info').find('.js-compare').attr('data-model-suffixcode'),
			price: price,
			currencyCode: $('.currency-code').val()
		})
	});
	//LGEGMCGA-28 End
	
});
/* LGCOMSPEED-6 Start */
var priceSyncGPC0007 = {
	el: $('.GPC0007'),
	priceTemplate: null,
	priceSyncInstallmentTemplate: null,
	categoryFilterForm: $('#categoryFilterForm'),
	init: function(){
		var _this = this;
		
		_this.priceTemplate = $('.priceSyncTemplateGPC0007').clone().html();
		_this.priceSyncInstallmentTemplate = $('.priceSyncInstallmentTemplateGPC0007').clone().html();
		$('.priceSyncTemplateGPC0007').remove();
		$('.priceSyncInstallmentTemplateGPC0007').remove();
		
		_this.getPrice();
	},
	getPrice: function(){			
		var _this = this;
		var categoryId = _this.categoryFilterForm.find('[name="categoryId"]').val()
		,modelStatusCode = _this.categoryFilterForm.find('[name="modelStatusCode"]').val()
		,bizType = _this.categoryFilterForm.find('[name="bizType"]').val();
		
		var	url = _this.categoryFilterForm.data('price-sync-url'),
			param = {
			categoryId: categoryId,
			modelStatusCode: modelStatusCode,
			bizType: bizType
			};
		
		/* LGEITF-779 Start */
		if(!!priceSyncGPC0007.el.find('#paramFilter').val()){
			var sortByFlag = priceSyncGPC0007.el.find('#paramFilter').val().split('&').find(function(item){ return item.indexOf('sortByFlag') > -1 })
			if(!!sortByFlag){
				param['sortByFlag'] = sortByFlag.split('=')[1];
			}
		}
		/* LGEITF-779 End */

		ajax.call(url, param, 'json', function(data){
			if(data.status == 'success' && data.data){
				var productList = data.data[0].productList;
				var obsInstallmentPriceDisableLink = data.data[0].obsInstallmentPriceDisableLink;	// LGETW-651 add
				var html = [];
				for (var i = 0; i < productList.length; i++) {
					
					var p = productList[i],
						template = priceSyncGPC0007.priceTemplate,
						installmentTemplate = priceSyncGPC0007.priceSyncInstallmentTemplate;
					
					if(p.modelStatusCode!='DISCONTINUED') {
						var priceValue = "";
						if(p.rPromoPrice != null && p.rPromoPrice != "" && p.rPromoPrice != 'null'){
							priceValue = p.rPromoPrice+"."+nvl(p.rPromoPriceCent,'00');
						} else{
							priceValue = nvl(p.rPrice,'')+"."+nvl(p.rPriceCent,'00');
						}
						//LGCOMIS-121 IT limitSaleTitle '' 분기
						installmentTemplate = installmentTemplate.replace(/\*emiMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')
															.replace(/\*obsProductCount\*/g, nvl(p.obsProductCount, '0'))
															.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode)
															.replace(/\*limitSaleTitle\*/g, COUNTRY_CODE.toLowerCase()=='it' ? '' : (p.limitSaleUseFlag == "Y" && p.obsLimitSale == 'Y') ? $('#limitSaleTitle').val() : '')
															.replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')
															.replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEGMC-3167 add, OBSLGEAU-749 (5000 -> 10000) */
															.replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')/* LGEGMC-3167 add */
						priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.price-vip-Installment').html('').removeClass('d-none').append(installmentTemplate);
						
						template = template.replace(/\*modelId\*/g, p.modelId)
										.replace(/\*retailerPricingText\*/g, p.retailerPricingText)
										.replace(/\*priceValue\*/g, priceValue) /* LGEGMC-712 20201020 add */
										.replace(/\*msrp\*/g, nvl(p.msrp,'0'))
										.replace(/\*membershipPrice\*/g, p.rMembershipPrice ? changeFormatFullPrice(p.rMembershipPrice, p.rMembershipPriceCent) : '') /* PJTMEMBERSHIP-4 */
										.replace(/\*membershipDisplayFlag\*/g, p.membershipDisplayFlag) /* PJTMEMBERSHIP-4 */
										.replace(/\*cheaperPrice\*/g, p.cheaperPrice ? changeFormatFullPrice(p.cheaperPrice, p.cheaperPriceCent) : '') /* LGEGMC-1973 */
										.replace(/\*cheaperPriceFlag\*/g, p.cheaperPriceFlag) /* LGEGMC-1973 */
										;
						
						var title = $("#openTarget").val();
						p.obsMembershipLinkTarget == '_blank' ? title : title = "";
						var obsMemberShipLinkStartHtml = "";
						var obsMemberShipLinkEndHtml = "";
						if(p.obsMembershipLinkUrl != "" && p.obsMembershipLinkUrl != null && p.membershipDisplayFlag == 'Y'){
							obsMemberShipLinkStartHtml = "<a href='"+ p.obsMembershipLinkUrl +"' target='"+ p.obsMembershipLinkTarget +"' title='" +title+ "'>";
							obsMemberShipLinkEndHtml = "</a>"
						} 
						template = template.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml);
						template = template.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml);
						
						//LGCOMITF-69 START
						if(!!p.obsWelcomePriceUseFlag && p.obsWelcomePriceUseFlag == "Y"){ //obsWelcomePriceUseFlag가 Y면 obsWelcomePrice, obsWelcomePriceDescription에 값이 존재함
							template = template.replace(/\*obsWelcomePrice\*/g, changeFormatFullPrice(p.obsWelcomePrice, p.obsWelcomePriceCent))
												.replace(/\*obsWelcomePriceDescription\*/g, p.obsWelcomePriceDescription);
							
							priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.coupon-price').removeClass('d-none');
						}else{
							priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.coupon-price').html('');
						}
						//LGCOMITF-69 END
						var $template = $(template);
						
						// price setting
						$priceArea = priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.price-area.total');
						if($priceArea.length!=0) {
							$priceArea.removeClass('type-none type-default type-msrp type-promotion type-text');
							if(p.modelStatusCode=='DISCONTINUED') {
								// do nothing
							} else if(p.retailerPricingFlag == "Y") {
								// type text
								$priceArea.addClass('type-text');
								$template.find('.text').text($priceArea.data('retailer-pricing-text'));
							} else if(p.rPromoPrice != null && p.rPrice != null && p.rPromoPrice != '' && p.rPrice != '') {
								// type promotion
								$priceArea.addClass('type-promotion');
								var price = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
								var pricePromo = changeFormatFullPrice(p.rPrice, p.rPriceCent);
								$template.find('.purchase-price .price .number').text(price);
								$template.find('.product-price .price .number').text(pricePromo);
								//[Start] LGEDE-1151 "has-uvp" 추가
                                if($template.find('.product-price .price.has-uvp').length>0) {
                                	$template.find('.product-price .price.has-uvp .number').text(pricePromo);
                                };
		                        //[End] LGEDE-1151
								$template.find('.product-price .legal').html(p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'));
							} else {
								if(p.bizType=="B2B" && p.obsLoginFlag != "Y") {
									if(p.rPrice != null && p.rPrice != '') {
										// type b2b
										var price1 = changeFormatFullPrice(p.rPrice, p.rPriceCent);
										$priceArea.addClass('type-msrp');
										$template.find('.purchase-price .price .number').text(price1);
									}
								} else {
									if(p.rPrice != null && p.rPrice != '') {
										// type default
										var price2 = changeFormatFullPrice(p.rPrice, p.rPriceCent);
										$priceArea.addClass('type-default');
										$template.find('.purchase-price .price .number').text(price2);
									}
								}
							}
						}
						
						if(p.membershipDisplayFlag != 'Y'){
							$template.find('.member-text').html('');
						}
						/* LGCOMPA-44 start */
						if(  SIGN_IN_STATUS == 'N'
						  && !!p.membershipDisplayFlag
						  &&   p.membershipDisplayFlag == 'Y'
						  && !!data.data[0].guestPriceMessageUseFlag
						  &&   data.data[0].guestPriceMessageUseFlag == 'Y'
						  && !!data.data[0].guestPriceMessage) {
							$template.find('.member-text').html('').append(data.data[0].guestPriceMessage);
						}
						/* LGCOMPA-44 end */
						if(p.cheaperPriceFlag != 'Y'){
							$template.find('.cheaper-text').html('');
						}
						
						// LGCOMMON-54, LGCOMPL-216 Start
						if(p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice) {
							if( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').removeClass('d-none');
							if( $template.find('.lowest-price').length ) $template.find('.lowest-price').removeClass('d-none');
						} else {
							if( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').html('');
							if( $template.find('.lowest-price').length ) $template.find('.lowest-price').html('');
						}
						// LGCOMMON-54, LGCOMPL-216 End
						
						price = $template.find('.price-area').html();
						member = $template.find('.member-text').get(0).outerHTML;
						cheaper = $template.find('.cheaper-text').get(0).outerHTML;
						const lowest = $template.find('.lowest-price').get(0).outerHTML; // LGECZ-429
						priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.member-text').remove();
						priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.cheaper-text').remove();
						// LGECZ-429 Start
						priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.lowest-price').remove();
						priceSyncGPC0007.el.find('.products-info[data-model-id='+p.modelId+']').find('.price-area.total').html('').removeClass('d-none').append(price).after(lowest).after(member).after(cheaper);
						// LGECZ-429 End
						
						/* LGETW-651 start */
						if(!!obsInstallmentPriceDisableLink && obsInstallmentPriceDisableLink == 'Y'){
							priceSyncGPC0007.el.find('.price-installment').addClass('no-link').attr('tabindex','-1');
						}
						/* LGETW-651 end */
					}
				}
				// LGECZ-402 Start
				if($('.GPC0007 .js-model .lowest-price:not(.d-none)').length) // LGCOMMON-54
					$('.GPC0007 .model-buy').addClass('has-lowPrice');
				// LGECZ-402 End
			}
		});
	}
}
/* LGCOMSPEED-6 End */

// LGEUK-896 End
var rePdslider = {
        recommendedPriceTemplate : null,
        init : function(){
            $('#recommendedPdGPC0007').on('shown.bs.modal', function (e) {
                console.log('base slick stard')
                rePdslider.getPriceSync();
                rePdslider.popSlick();
            });
            $('#recommendedPdGPC0007').on('hidden.bs.modal', function (e) {
                console.log('base slick end');
                rePdslider.unpopSilck();
            });
            $(window).on('resize', function(){
                rePdslider.resize();
            });

            this.recommendedPriceTemplate = $('#priceSyncRecommendedTemplateGPC0007').clone().html();
            $('#priceSyncRecommendedTemplateGPC0007').remove();
            
            
        },
        getPriceSync: function(){
            var recommendedPd = $('#recommendedPdGPC0007');
            var modelIdArr = new Array();
            var bizTypeArr = new Array();
            var modelStatusCodeArr = new Array();
            recommendedPd.find('input[name=recommendedModelId]').each(function(idx){
                modelIdArr[idx] = $(this).val();
                bizTypeArr[idx] = recommendedPd.find('input[name=recommendedBizType]').eq(idx).val();
                modelStatusCodeArr[idx] = recommendedPd.find('input[name=recommendedModelStatusCode]').eq(idx).val();
            });
            
            var _this = this,
                url = $('.GPC0007').find('input[name=recommendedPriceSyncAjaxUrl]').val(),
                param = {
                    modelId: modelIdArr.join(),
                    bizType: bizTypeArr[0],
                    modelStatusCode: modelStatusCodeArr[0]
                };

            ajax.noCacheCall(url, param, 'json', function(data){
                if(data.status == 'success' && data.data){
                    for(var i=0; i<data.data[0].recommendedProducts.length; i++){
                        var p = data.data[0].recommendedProducts[i],
                            priceSyncRecommendedHtml = _this.recommendedPriceTemplate;
                        
                        if (priceSyncRecommendedHtml) {
                            $template = _this.makePriceSyncHtml(p, priceSyncRecommendedHtml);
                            var scop = $('.recommendedModelList[data-recommended-model-id='+p.recommendedModelId+']').find('.products-info');
                            scop.find('.price-vip-Installment, .dx-price-area, .member-text').remove(); // LGCOMMON-54
                            scop.find('.pd-model').after($template);
                        }
                    }
                }
            });
        },
        makePriceSyncHtml : function(p, template){
            if (template) {
                //replace
                var emiMsgFlag = p.recommendedObsEmiMsgFlag;
                var afterPay = p.recommendedAfterPay;
                
                template = template.replace(/\*recommendedModelId\*/g, p.recommendedModelId)
                .replace(/\*recommendedMembershipPrice\*/g, !!p.recommendedMembershipPriceCent ? changeFormatFullPriceSync(p.recommendedMembershipPrice, p.recommendedMembershipPriceCent) : (!!p.recommendedMembershipPrice ? changeFormatPriceSync(p.recommendedMembershipPrice) : ''))
                .replace(/\*recommendedSalesModelCode\*/g, !!p.recommendedSalesSuffixCode ? p.recommendedSalesModelCode+'.'+p.recommendedSalesSuffixCode : p.recommendedSalesModelCode)
                .replace(/\*recommendedEmiMsg\*/g, p.recommendedEmiMsg)
                .replace(/\*display\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 3000) ? '' : 'style="display:none;"')
                .replace(/\*zipdisplay\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 10000) ? '' : 'style="display:none;"') /* OBSLGEAU-749 (5000 -> 10000) */
                .replace(/\*orZipPay\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 3000) ? 'or ' : '');
            
                //jquery set
                var $html = $(template);
                
                //rPrice, rPromoPrice
                var recommendedRPrice = '';
                var recommendedRPromoPrice = '';
                
                if (!!p.recommendedRPromoPriceCent) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPromoPrice, p.recommendedRPromoPriceCent);
                    recommendedRPromoPrice = changeFormatFullPriceSync(p.recommendedRPrice, p.recommendedRPriceCent);
                } else if (!!p.recommendedRPromoPrice) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPromoPrice);
                    recommendedRPromoPrice = changeFormatFullPriceSync(p.recommendedRPrice);
                } else if (!!p.recommendedRPriceCent) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPrice, p.recommendedRPriceCent);
                } else if (!!p.recommendedRPrice) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPrice);
                }
                
                $html.find('.purchase-price .number').text(recommendedRPrice);
                $html.find('.product-price .number').text(recommendedRPromoPrice);
                $html.find('.dx-price-area .legal').text(p.recommendedDiscountMsg);
                
                //type
                if(p.recommendedRetailerPricingFlag1 == 'Y'){
                    $html.find('.dx-price-area').addClass('type-text');
                }else if(!!p.recommendedRPromoPrice){
                    $html.find('.dx-price-area').addClass('type-promotion');
                }else if(p.recommendedBizType == 'B2B' && $html.data('obs-login-flag') != 'Y' && !!p.recommendedRPrice){
                    $html.find('.dx-price-area').addClass('type-msrp');
                }else if(!!p.recommendedRPrice){
                    $html.find('.dx-price-area').addClass('type-default');
                }else{
                    $html.find('.dx-price-area').addClass('type-none');
                }
                
                //membership
                if(p.recommendedMembershipDisplayFlag != 'Y'){
                    $html.find('.member-text').remove();
                }
                
                //price-vip
                if(p.recommendedLimitSaleUseFlag == 'Y' && p.recommendedObsLimitSale == 'Y'){
                    $html.find('.price-vip-Installment .price-vip').text($html.find('.price-vip-Installment .price-vip').data('limit-sale-title'));
                }
                
                if(!!!p.recommendedEmiMsg){
                    $html.find('.price-installment').remove();
                }
                
                return $html.html();
            }
        },
        popSlick : function(){
            $('.re-pd-slider ul.slider').slick({
                listStyle: false, 
                autoplay: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },{
                        breakpoint: 640,
                        settings: "unslick"
                    }
                ]
            });
            console.log('base slick load')
        },
        unpopSilck : function(){
            if($('.re-pd-slider ul.slider').hasClass('slick-initialized') == true){
                var $slick = $('.re-pd-slider ul.slider').slick('unslick');
            } else{
                return false
            }
        },
        resize : function(){
            var delay = 500;
            var timer = null;
            var $winW = $(window).width(); 
            clearTimeout(timer);
            timer = setTimeout(function(){              
                if ( $winW >= 640 && $("#recommendedPdGPC0007").hasClass('show')) {
                    if($('.re-pd-slider ul.slider').hasClass('slick-initialized') !== true){
                        rePdslider.popSlick();
                    }
                } else{
                    console.log("unsilck")
                    rePdslider.unpopSilck();
                }
            }, delay);
        }
    }
    rePdslider.init();
// LGEUK-896 End